<script>
    import { loggedIn } from "../services/Auth";

    let username = "";
    let password = "";

    let authenticationFailed = false;
    let invalidForm = false;
    let loadingRequest = false;

    import API from "../services/Api";

    let submitForm = async (e) => {
        e.preventDefault();

        authenticationFailed = false;

        if ("" === username || "" === password) {
            invalidForm = true;
            return;
        } else {
            invalidForm = false;
        }

        loadingRequest = true;

        await API.post("adapter/users/login", {
            username,
            password,
        })
        .then(async (response) => {
            if (!response.data) {
                authenticationFailed = true;
                loadingRequest = false;
                return;
            }
            $loggedIn = true;
            sessionStorage.setItem('token', response.data.token.access_token);
            sessionStorage.setItem('user', response.data.NomeUsuario);
            sessionStorage.setItem('userID', response.data.IDUsuario);
            sessionStorage.setItem('isTecnico', response.data.IsTecnico);
            loadingRequest = false;
        })
        .catch((response) => {
            authenticationFailed = true;
            loadingRequest = false;
        });
    };
</script>

<main class="container">

    <div class="mx-1 my-3"  style="max-width: 500px;">
        <img class="img-fluid" src="./mobwire-logo.jpeg" alt="Logo Mobwire"/>
    </div>

    <h3 class="text-center">Seja bem-vindo!</h3>
    <p />
    <div class="card">
        <div class="card-body">
            <form id="loginForm">
                <div class="form-group">
                    <label for="username"><b>Usuário</b></label>
                    <input
                        id="username"
                        type="text"
                        bind:value={username}
                        class="form-control"
                    />
                </div>
                <div class="form-group">
                    <label for="password"><b>Senha</b></label>
                    <input
                        id="password"
                        type="password"
                        bind:value={password}
                        class="form-control"
                    />
                </div>
                <div class="form-group">
                    {#if loadingRequest}
                        <button class="btn btn-danger btn-block" disabled>
                            <b>Aguarde...</b>
                        </button>
                    {:else}
                        <button
                            class="btn btn-danger btn-block"
                            on:click={submitForm}><b>Entrar</b></button
                        >
                    {/if}
                </div>

                {#if authenticationFailed}
                    <div class="alert alert-light text-center text-danger">
                        Usuário e/ou senha inválidos.<br />Verifique os dados e
                        tente novamente!
                    </div>
                {/if}

                {#if invalidForm}
                    <div class="alert alert-light text-center text-danger">
                        Os campos acima são obrigatórios!
                    </div>
                {/if}
            </form>
        </div>
    </div>
</main>

<style>
    main {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 100%;
        justify-content: center;
        align-items: center;
    }

    .card {
        min-width: 350px;
    }
</style>
